module.exports = __webpack_public_path__ + "static/img/Harp-of-Erin.c00a977.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harp-of-Erin.jpg
// module id = vRS3
// module chunks = 0